export function formatCompact(value, { currency = false, percent = false } = {}) {
    if (value == null || !Number.isFinite(Number(value))) return '—';
    if (percent) {
        return `${(Number(value) * 100).toFixed(1)}%`;
    }
    return new Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 2,
        style: currency ? 'currency' : 'decimal',
        currency: currency ? 'USD' : undefined,
    }).format(Number(value));
}

export function formatSharePrice(value) {
    if (value == null || !Number.isFinite(Number(value))) return '—';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number(value));
}

export function parseAbbreviatedNumber(value) {
    const raw = String(value ?? '').trim();
    const negativeParens = raw.startsWith('(') && raw.endsWith(')');
    const normalized = raw
        .replace(/[(),$%\s]/g, '')
        .replace(/x$/i, '')
        .toLowerCase();
    const match = normalized.match(/^(-?(?:\d+\.?\d*|\.\d+))([kmbt])?$/);
    if (!match) return null;
    const multipliers = { k: 1e3, m: 1e6, b: 1e9, t: 1e12 };
    const magnitude = Number(match[1]) * (multipliers[match[2]] || 1);
    if (!Number.isFinite(magnitude)) return null;
    return negativeParens ? -Math.abs(magnitude) : magnitude;
}
